import Swiper, { EffectFade, Pagination, Autoplay } from "swiper";

/** Block Home Slider */
export function blockHomeSlider() {
  new Swiper(".home-slider__swiper", {
    modules: [EffectFade, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}
